<template>
  <div class="volunteer-profile">
    <!-- Skeleton Loader -->
    <v-skeleton-loader
      v-if="isLoading"
      type="card, list-item-avatar, list-item, list-item, list-item"
      class="skeleton-loader"
      elevation="1"
    />

    <!-- Actual Profile Card -->
    <v-card class="profile-card" v-else-if="volunteer" flat>
      <!-- Header -->
      <div class="profile-header">
        <v-card-title class="volunteer-name">
          <span v-text="volunteer.first_name + ' ' + volunteer.last_name" />
        </v-card-title>
      </div>
      <!-- Causes as chips -->
      <v-card-text class="causes-section">
        <!-- <h2 class="causes-title">Causes</h2> -->
        <site-icon
          :name="icon"
          type="Cause"
          v-for="(icon, key) in volunteer.causes"
          :key="key"
          :size="40"
          class="mb-3 mr-3"
        />
      </v-card-text>
      <!-- About Me -->
      <v-expansion-panels flat multiple class="profile-sections">
        <v-expansion-panel>
          <v-expansion-panel-header class="section-header">
            About Me
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="section-content" v-text="volunteer.about_me" />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Contact Info -->
        <v-expansion-panel>
          <v-expansion-panel-header class="section-header">
            <!-- <v-icon left color="#084468">mdi-account-box-outline</v-icon> -->
            Information
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="contact-item" v-if="volunteer.phone">
              <v-icon small color="#fdbc3a">mdi-phone</v-icon>
              <a :href="`tel:${volunteer.phone}`" class="contact-link">
                {{ formatPhoneNumber(volunteer.phone) }}
              </a>
            </div>

            <div class="contact-item" v-if="volunteer.email">
              <v-icon small color="#fdbc3a">mdi-email</v-icon>
              <a :href="`mailto:${volunteer.email}`" class="contact-link">
                {{ volunteer.email }}
              </a>
            </div>

            <div
              class="contact-item"
              v-if="volunteer.address || volunteer.city"
            >
              <v-icon small color="#fdbc3a">mdi-map-marker</v-icon>
              <span>
                {{ volunteer.address }}, {{ volunteer.city }},
                {{ volunteer.state }} {{ volunteer.zip }}
              </span>
            </div>

            <div class="contact-item" v-if="volunteer.address2">
              <v-icon small color="#fdbc3a">mdi-map-marker</v-icon>
              <span>
                {{ volunteer.address2 }}, {{ volunteer.city }},
                {{ volunteer.state }} {{ volunteer.zip }}
              </span>
            </div>

            <div class="contact-item">
              <v-icon small color="#fdbc3a">mdi-account-group</v-icon>
              <span>{{ volunteer.age_group }}</span>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SiteIcon from "@/components/common/SiteIcon.vue";
export default {
   components: {  SiteIcon },
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    ...mapGetters({
      profile: "auth/getProfile",
      profileType: "auth/getType",
      volunteer: "volunteer/getVolunteer"
    })
  },
  watch: {
    volunteer: {
      handler(newVal) {
        if (newVal) {
          this.isLoading = false;
        }
        console.log(this.volunteer);
      },
      immediate: true
    }
  },
  methods: {
    formatPhoneNumber(str) {
      let cleaned = ("" + str).replace(/\D/g, "");
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        let intlCode = match[1] ? "+1 " : "";
        return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          ""
        );
      }
      return str;
    }
  },
  mounted() {
    // Check if volunteer data is already available when component mounts
    if (this.volunteer) {
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.skeleton-loader {
  max-width: 400px;
  margin: auto;
  margin-top: 32px;
}

.volunteer-profile {
  max-width: 100%;
  width: 100%;
  padding: 16px;
}

.profile-card {
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden;
}

.profile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 16px;
  background: linear-gradient(135deg,  #084468 0%, #3b7ca1 100%);
}

.volunteer-name {
  color: white !important;
  font-weight: 600;
  font-size: 1.5rem;
  text-align: center;
  padding: 0;
  width: 100%;
}

.profile-sections {
  margin-top: 8px;
}

.section-header {
  font-weight: 600;
  color: #084468 !important;
  min-height: 48px;
  
}

.section-header .v-icon {
  margin-right: 8px;
}

.causes-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 12px !important;
  background-color: #f8f9fa;
}

.causes-title{
  font-weight: 600;
  color: #084468 !important;
  /* text-align: center; */
  width: 100%;  
  margin-bottom: 6px;
}

.section-content {
  padding: 8px 16px;
  line-height: 1.6;
  color: #555;
}

.contact-item {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  color: #555;
}

.contact-item .v-icon {
  margin-right: 12px;
}

.contact-link {
  color: #084468;
  text-decoration: none;
  margin-left: 8px;
}

.contact-link:hover {
  text-decoration: underline;
}

/* Responsive adjustments */
@media (min-width: 960px) {
  .volunteer-profile {
    max-width: 400px;
    padding: 24px 16px;
  }
  .profile-header {
    flex-direction: row;
    justify-content: flex-start;
    padding: 24px;
  }
  .volunteer-name {
    text-align: left;
  }
}
</style>
